import type { CheckStatus, CheckType, ExecutionDisclosure, VerificationBoundary } from "../wire/research.ts";

/** The Chinese names of the verification domain: the report disclosure and the research views show them alike. */
export const CHECK_TYPE_LABEL: Record<CheckType, string> = {
	source_identity: "来源身份",
	source_quote: "原文引语",
	claim_support: "论点支持",
	data_recompute: "数据重算",
	human_judgment: "人工裁定",
	role_consensus: "角色共识",
};

export const CHECK_STATUS_LABEL: Record<CheckStatus, string> = {
	executed: "已执行",
	not_run: "未执行",
	inconclusive: "未定论",
	failed: "核验失败",
};

export const EXECUTION_MODE_LABEL: Record<ExecutionDisclosure["mode"], string> = {
	unknown: "未知",
	single_session: "单一会话",
	dispatched_contexts: "已派发多个上下文",
};

export const CONTEXT_DISPATCH_LABEL: Record<ExecutionDisclosure["contextDispatch"], string> = {
	unknown: "未知",
	single_context: "单一上下文",
	separate_contexts: "多个上下文",
};

export const SIBLING_READ_LABEL: Record<ExecutionDisclosure["siblingReadConstraint"], string> = {
	prompt_only: "提示级",
	observed_violation: "已发现违反",
	unknown: "未知",
};

export const MODEL_OVERLAP_LABEL: Record<ExecutionDisclosure["overlap"]["modelOverlap"], string> = {
	same_model: "同一模型",
	different_models: "不同模型",
	unknown: "未知",
};

export const SOURCE_OVERLAP_LABEL: Record<ExecutionDisclosure["overlap"]["sourceOverlap"], string> = {
	shared_sources: "共用来源",
	distinct_sources: "来源不同",
	unknown: "未知",
};

export const BOUNDARY_LEVEL_LABEL: Record<VerificationBoundary["level"], string> = {
	prompt_only: "提示级",
	enforced: "平台强制",
	unknown: "未知",
};

export const RECEIPT_RELATION_LABEL = {
	this_session: "本会话",
	delegate_child: "委派子会话",
	delegate_job: "委派任务",
} as const;
